import PricingStrategies from './pricing-strategies'

export default [
  {
    name: 'Code',
    prop: 'code',
    type: 'text'
  },
  {
    name: 'Name',
    prop: 'name',
    type: 'text'
  },
  {
    name: 'Description',
    prop: 'description',
    type: 'textarea',
    rows: 10
  },
  {
    name: 'Price',
    prop: 'price',
    type: 'text'
  },
  {
    name: 'Pricing Strategies',
    prop: 'pricing_strategies',
    type: 'component',
    component: PricingStrategies
  }
]
